import React from 'react';
import { AlertCircle } from 'lucide-react';
export function Hook() {
  return <section className="bg-navy-800 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-102">
      <div className="mx-auto max-w-3xl text-center" data-id="element-103">
        <div className="mb-8 flex justify-center" data-id="element-104">
          <div className="rounded-full bg-red-500/10 p-4" data-id="element-105">
            <AlertCircle className="h-10 w-10 text-red-500" data-id="element-106" />
          </div>
        </div>

        <h2 className="mb-8 text-3xl sm:text-4xl font-bebas text-white leading-tight" data-id="element-107">
          Tu puntaje bajo <span className="text-red-400" data-id="element-108">no es tu culpa.</span>
        </h2>

        <div className="space-y-6 text-lg text-slate-300 text-left" data-id="element-109">
          <p data-id="element-110">
            Es el resultado de un sistema diseñado para que nunca lo entiendas.
            Experian, TransUnion y Equifax tienen errores en millones de
            reportes.
          </p>
          <p className="font-medium text-white border-l-4 border-gold-400 pl-4 py-2 bg-navy-900/50 rounded-r-lg" data-id="element-111">
            El problema es que nadie te enseña cómo encontrarlos — ni cómo
            forzarlos a corregirlos por ley. Eso cambia hoy.
          </p>
        </div>
      </div>
    </section>;
}